export type CarouselFontOption = {
  id: string;
  label: string;
  fontFamily: string;
  category?: string;
  description?: string;
};

// Единый список разрешённых шрифтов для HTML-карточек карусели.
// Составлен на основе популярных трендов и запросов пользователя.
export const CAROUSEL_FONTS: CarouselFontOption[] = [
  // Гротески (Без засечек) — читаемые, нейтральные, для основного текста
  {
    id: 'open-sans',
    label: 'Open Sans',
    fontFamily: "Open Sans",
    category: 'Гротеск',
    description: 'Нейтральный, открытый гуманистический гротеск. Максимально разборчивый, простой и ненавязчивый'
  },
  {
    id: 'inter',
    label: 'Inter',
    fontFamily: "Inter",
    category: 'Гротеск',
    description: 'Шрифт, созданный специально для экранов. Четкий, строгий, нейтральный, стерильный'
  },
  {
    id: 'fira-sans',
    label: 'Fira Sans',
    fontFamily: "Fira Sans",
    category: 'Гротеск',
    description: 'Гуманистический гротеск с большим набором начертаний. Технический, но мягкий'
  },
  {
    id: 'geologica',
    label: 'Geologica',
    fontFamily: "Geologica",
    category: 'Гротеск',
    description: 'Современный вариативный гротеск. Округлый, гладкий, технологичный, но при этом гуманистичный и дружелюбный'
  },
  {
    id: 'montserrat',
    label: 'Montserrat',
    fontFamily: "Montserrat",
    category: 'Акцентный',
    description: 'Геометрический гротеск. Широкий, устойчивый, современный. В жирном начертании выглядит очень авторитетно'
  },
  {
    id: 'science-gothic',
    label: 'Science Gothic',
    fontFamily: "Science Gothic",
    category: 'Акцентный',
    description: 'Футуристичный, конструктивный гротеск. Выглядит индустриально и космически'
  },
  {
    id: 'oswald',
    label: 'Oswald',
    fontFamily: "Oswald",
    category: 'Акцентный',
    description: 'Узкий геометрический гротеск. Идеален для плотных, мощных заголовков'
  },
  {
    id: 'rubik',
    label: 'Rubik',
    fontFamily: "Rubik",
    category: 'Гротеск',
    description: 'Современный гротеск с мягкими скругленными углами. Дружелюбный и технологичный'
  },
  {
    id: 'russo-one',
    label: 'Russo One',
    fontFamily: "Russo One",
    category: 'Акцентный',
    description: 'Мощный, жирный, блочный шрифт без засечек. Конструктивистский, индустриальный, громкий'
  },

  // Антиквы (С засечками) — классика, элегантность, люкс
  {
    id: 'playfair-display-cyrillic',
    label: 'Playfair Display Cyrillic',
    fontFamily: "Playfair Display Cyrillic",
    category: 'Антиква',
    description: 'Контрастная антиква. Элегантный, глянцевый, с тонкими линиями. Стиль обложек Vogue и Harper Bazaar'
  },
  {
    id: 'great-vibes',
    label: 'Great Vibes',
    fontFamily: "Great Vibes",
    category: 'Каллиграфический',
    description: 'Элегантный, плавный каллиграфический шрифт с завитушками. Имитирует красивый росчерк пером'
  },

  // Рукописные и творческие — неформальные, душевные, игровые
  {
    id: 'caveat',
    label: 'Caveat',
    fontFamily: "Caveat",
    category: 'Рукописный',
    description: 'Аккуратный рукописный шрифт. Выглядит как разборчивая запись маркером на доске или в блокноте'
  },
  {
    id: 'shantell-sans',
    label: 'Shantell Sans',
    fontFamily: "Shantell Sans",
    category: 'Рукописный',
    description: 'Игривый шрифт в стиле маркер на доске. Сочетает читаемость гротеска с энергией комикса'
  }
];

export const DEFAULT_CAROUSEL_FONT_ID = 'inter';
